export interface CostAccountingDairenArray {
  id: number;
  projectNo: string;
  projectName: string;
  startDate: string;
  endDate: string;
  manHour: string;
  manHoursCostGen: string;
  manHoursCostYenMonthEnd: string;
  manHoursCostYenMonthAverage: string;
  manHoursCostYenTotalAverage: string;
}

export interface CostAccountingDairenTotalArray {
  totalManHour: string;
  totalManHoursCostGen: string;
  totalManHoursCostYenMonthEnd: string;
  totalManHoursCostYenMonthAverage: string;
  totalManHoursCostYenTotalAverage: string;
}

export type CostAccountingDairenGetResponse = {
  items: CostAccountingDairenArray[];
  totalItems: CostAccountingDairenTotalArray;
  page: number;
  totalPages: number;
};

export const EmptyCostAccountingDairenGetResponse: CostAccountingDairenGetResponse =
  {
    items: [],
    totalItems: {
      totalManHour: '0',
      totalManHoursCostGen: '0',
      totalManHoursCostYenMonthEnd: '0',
      totalManHoursCostYenMonthAverage: '0',
      totalManHoursCostYenTotalAverage: '0',
    },
    page: 1,
    totalPages: 0,
  };
